import type { Stance } from '../rules/types';

export const STANCE_LABEL: Record<Stance, string> = {
  buy: 'Buy', watch: 'Watch', hold: 'Hold', sell: 'Sell',
};

/**
 * Colour is never the only signal — the badge always carries its word too, so the meaning
 * survives for colour-blind readers and in a screenshot printed in greyscale. Same discipline
 * the Mac app follows for gain/loss.
 */
export default function StanceBadge({ stance }: { stance: Stance }) {
  return <span className={`badge ${stance}`}>{STANCE_LABEL[stance]}</span>;
}
